import React, { useState, useEffect } from 'react'
import resources from '../../../services'
import Btn from '../../../ui/Btn'
import { Field } from '../../../ui/Field'
import Select from 'react-select'
import moment from 'moment'
import UpdatePage from '../../../composents/UpdatePage'

const title = 'Pay Back'
const headers = {
  icon: 'feather icon-plus',
  title,
  description: 'pay back',
  breadcrumbs: [
    {
      title,
      link: '/clients/top_up',
    },
  ],
}

const cardOptions = [
  {
    value: 'cash',
    label: 'Cash',
  },
  {
    value: 'card',
    label: 'Card',
  },
]

export default function PayBackConsumer() {
  const [loader, setLoader] = useState(false),
    [errors, setErrors] = useState({}),
    [data, setData] = useState({}),
    [consumer, setConsumer] = useState(),
    [fail, setFail] = useState(false),
    [loading, setLoading] = useState(true),
    [option, setOption] = useState({
      value: 'cash',
      label: 'Cash',
    })

  async function onGet() {
    setLoading(true)
    const response = await resources.consumer
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (response.status === 200) {
      setData(
        response.data.docs.map((e) => ({
          value: e.id,
          label: e.surname,
          client: e.client.id,
          balance: e.balance,
          wallet: e.wallet,
        }))
      )
    } else if (response.status === 403) {
      setFail(true)
    }

    setLoading(false)
  }

  useEffect(() => {
    onGet()
  }, [])

  /**
   * @param {React.FormEvent<HTMLFormElement>} e
   */
  async function onCreate(e) {
    e.preventDefault()
    let formData = new FormData(e.target)
    let object = Object.fromEntries(formData)
    object.payment = option.value
    if (consumer) object.consumer = consumer.value
    setLoader(true)
    setErrors({})
    let res = await resources.payBack
      .create(object)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (res.status === 200) {
      sessionStorage.setItem('success', true)
      window.location.replace('/clients/paybacks')
    } else if (res.status === 422) {
      const errors = res.data.errors.reduce((acc, error) => {
        return { ...acc, [error.field]: error.message }
      }, {})
      setErrors(errors)
    } else if (res.status === 403) {
      setErrors({ not_autorized: true })
    }
    setLoader(false)
  }

  return (
    <UpdatePage
      show_error={errors['not_autorized']}
      loading={loading}
      fail={fail}
      headers={headers}
      message="this page require clients,cards,subscriptions and consumers authorization"
    >
      <form onSubmit={onCreate}>
        <div className="row justify-content-center mt-3 mb-3">
          <div className="col-lg-6 ">
            <div className="card">
              <div className="card-header">
                <h5>Information</h5>
              </div>
              <div className="card-body">
                <div className="form-group mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Consumer
                  </label>
                  <Select
                    onChange={(e) => {
                      setConsumer(e)
                    }}
                    options={data}
                    value={consumer}
                    isSearchable
                    isClearable
                    className={errors['consumer'] ? ' is-invalid' : ''}
                  />
                  {errors['consumer'] && (
                    <div className="invalid-feedback">{errors['consumer']}</div>
                  )}
                </div>

                <Field className="mb-3" value={consumer?.wallet ?? 0} readOnly type="number">
                  Wallet balance
                </Field>

                <Field
                  className="mb-3"
                  type="number"
                  error={errors['payBack']}
                  required
                  name="payBack"
                >
                  Pay Back
                </Field>

                <div className="mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Pay Back option
                  </label>
                  <Select
                    name="type"
                    onChange={setOption}
                    options={cardOptions}
                    value={option}
                    isSearchable
                    isClearable={false}
                    className={errors['payment'] ? ' is-invalid' : ''}
                  />
                  {errors['payment'] && <div className="invalid-feedback">{errors['payment']}</div>}
                </div>

                <div className="row ">
                  <div className="col-lg-12">
                    <div className="d-grid gap-2">
                      <Btn class="btn waves-effect waves-light btn-primary" onLoad={loader}>
                        <i className="feather icon-save"></i> Submit
                      </Btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </UpdatePage>
  )
}
